import TwoFactorAuthentication from "./TwoFactorAuthentication.page";

export default TwoFactorAuthentication;
